export default __webpack_public_path__ + "static/media/B_wdt_c_cap_3.f60932f2.mp3";